import { createAsyncThunk } from '@reduxjs/toolkit'
import { MediaDeliveryMapping } from '@internal/services/MediaDeliveryService'
import MediaService, { MediaMapping } from '@internal/services/MediaService'
import { IReduxThunkArg, IReduxThunkReturned } from './redux.types'
import { ReduxBaseTable } from '@lib/ReduxBase'
import { RootState } from '@internal/redux'
import { MediaQueryParam } from '@shared/Services/QueryParamService'

export const fetchMediaThunk = createAsyncThunk<IReduxThunkReturned, IReduxThunkArg | undefined>('fetchMediaThunk', async (param, thunkAPI) => {
  const deliveryId = MediaQueryParam.get().deliveryId
  if (!deliveryId) throw new Error('DeliveryId is required')

  const state = thunkAPI.getState() as RootState
  const tableInfoParam = ReduxBaseTable.ThunkArgMapping({ tableInfo: state.MediaSlice.tableInfo, ...param })

  const filter = MediaMapping.tableInfoToFilter(tableInfoParam, deliveryId)
  const res = await MediaService.AllGraphQL(filter, deliveryId, thunkAPI.signal)

  const tableInfo = ReduxBaseTable.ThunkReponseMapping(tableInfoParam, {
    Data: MediaMapping.medias(res.medias?.items),
    Total: res.medias?.totalItems
  })
  // ReduxBaseTable.setParam<IMedia>(tableInfo, DefaultSlice.initialState.tableInfo)
  return {
    tableInfo,
    delivery: res.mediaDelivery ? MediaDeliveryMapping.delivery(res.mediaDelivery) : undefined,
    categories: MediaMapping.categories(res.categories?.items)
  }
})
